import React, { FC } from 'react';
import { PlayerID, TeamID } from '../../../scripts/models/common';
import { Modification } from '../../../scripts/models/models';
import { capitalize } from '../../../scripts/utility';

import './ModificationsDisplay.scss';

type modificationWrapper = {
    teamId: TeamID,
    modification: Modification
} | {
    playerId: PlayerID,
    modification: Modification
}

interface IProps {
    modifications: (modificationWrapper | Modification)[]
}

function isNewModification(obj: modificationWrapper | Modification): obj is Modification {
    return (obj as any).modification === undefined
}


const ModificationsDisplay: FC<IProps> = (props) => {
    const { modifications } = props

    return <div className='ModificationsDisplay'>
        {
            modifications.map((wrapper, idx) => {
                let modification = isNewModification(wrapper) ? wrapper : wrapper.modification
                return (
                    <div key={idx}>
                        <span>{capitalize(modification.name)}</span>
                        {
                            modification.description ? (
                                <span> - {modification.description}</span>
                            ) : (
                                <></>
                            )
                        }

                    </div>
                )
            })
        }
    </div>
}

export default ModificationsDisplay;